var _polygon, _rect, _rect2, _rect3, _polygon2, _rect4, _rect5, _rect6, _polygon3, _rect7, _path, _path2, _rect8, _rect9, _rect10, _rect11, _path3, _path4, _rect12, _path5, _path6, _rect13, _path7, _path8, _path9, _path10, _path11, _path12, _circle, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _circle2, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _ellipse, _circle3, _circle4, _circle5, _circle6, _path30, _path31, _path32, _path33, _path34, _path35, _circle7, _circle8, _circle9, _circle10, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _polygon4, _polygon5, _path43, _circle11, _path44, _polygon6, _polygon7, _path45, _circle12;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeaderSvg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    width: 590.57466,
    height: 740,
    viewBox: "0 0 590.57466 740",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "589.458 489.77 22.16 489.77 22.16 508.07 110.635 508.07 110.635 681.92 129.503 680.981 128.935 508.07 473.533 508.07 473.533 681.92 491.371 686.617 491.833 508.07 589.458 508.07 589.458 489.77",
    fill: "#e6e6e6"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 23.27684,
    y: 435.02102,
    width: 567.29782,
    height: 18.29993,
    fill: "#e6e6e6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 23.27684,
    y: 389.2712,
    width: 567.29782,
    height: 18.29993,
    fill: "#e6e6e6"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 23.27684,
    y: 343.52137,
    width: 567.29782,
    height: 18.29993,
    fill: "#e6e6e6"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "589.458 489.77 22.16 489.77 22.16 508.07 110.635 508.07 110.635 681.92 129.503 680.981 128.935 508.07 473.533 508.07 473.533 681.92 491.371 686.617 491.833 508.07 589.458 508.07 589.458 489.77",
    fill: "#e6e6e6"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 23.27684,
    y: 435.02102,
    width: 567.29782,
    height: 18.29993,
    fill: "#e6e6e6"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 23.27684,
    y: 389.2712,
    width: 567.29782,
    height: 18.29993,
    fill: "#e6e6e6"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 23.27684,
    y: 343.52137,
    width: 567.29782,
    height: 18.29993,
    fill: "#e6e6e6"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "168.216 296.657 94.102 313.618 62.788 254.558 126.161 229.816 168.216 296.657",
    fill: "#2f2e41"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 216.64441,
    y: 338.05165,
    width: 212.38607,
    height: 8.11667,
    fill: "#3f3d56"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M695.86538,390.9961H692.065a8.06721,8.06721,0,0,0,1.09484-4.05833V373.41a8.11664,8.11664,0,0,0-8.11666-8.11666h-3.17735a8.08356,8.08356,0,0,0,.47179-2.70556V349.06a8.11665,8.11665,0,0,0-8.11666-8.11667H582.23206A8.11665,8.11665,0,0,0,574.1154,349.06v13.52777a8.08356,8.08356,0,0,0,.47179,2.70556h-3.17735a8.11664,8.11664,0,0,0-8.11666,8.11666v13.52778a8.06815,8.06815,0,0,0,1.09475,4.05833h-3.80031a8.11665,8.11665,0,0,0-8.11666,8.11667v13.52777a8.11665,8.11665,0,0,0,8.11666,8.11667H695.86538a8.11665,8.11665,0,0,0,8.11666-8.11667V399.11277A8.11665,8.11665,0,0,0,695.86538,390.9961Z",
    transform: "translate(-304.71267 -80)",
    fill: "#6c63ff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M679.632,342.97251c0-3.36206-23.015-6.08752-51.40552-6.08752s-51.40552,2.72546-51.40552,6.08752c0,1.67013,5.68364,3.18282,14.8805,4.28268v5.5249a1.696,1.696,0,0,0,1.691,1.691h.6765a1.696,1.696,0,0,0,1.691-1.691v-5.0886c2.11936.2047,4.38321.38889,6.76389.552v4.53657a1.69589,1.69589,0,0,0,1.691,1.691h.67637a1.696,1.696,0,0,0,1.691-1.691v-4.286c6.20422.34162,13.0782.54033,20.327.562a1.67,1.67,0,0,0-.03537.3421v6.08753a1.69588,1.69588,0,0,0,1.691,1.691h.67636a1.696,1.696,0,0,0,1.691-1.691v-6.08753a1.681,1.681,0,0,0-.03661-.3463c6.23312-.03777,12.17-.20772,17.62269-.48542v5.56646a1.696,1.696,0,0,0,1.691,1.691h.67636a1.69588,1.69588,0,0,0,1.691-1.691v-5.79834c5.692-.36323,10.73288-.85051,14.88064-1.4302v4.523a1.69592,1.69592,0,0,0,1.691,1.691h.67636a1.696,1.696,0,0,0,1.691-1.691v-5.17371C676.64513,345.30661,679.632,344.18122,679.632,342.97251Z",
    transform: "translate(-304.71267 -80)",
    fill: "#e6e6e6"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 269.40273,
    y: 283.94055,
    width: 108.2222,
    height: 2.70556,
    fill: "#3f3d56"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 259.93329,
    y: 309.64332,
    width: 127.16109,
    height: 2.70556,
    fill: "#3f3d56"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 250.46384,
    y: 333.99332,
    width: 147.45275,
    height: 2.70556,
    fill: "#3f3d56"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 320.80828,
    y: 239.29889,
    width: 4.05833,
    height: 22.99722,
    fill: "#e6e6e6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M633.31881,316.4199c0,4.611-2.56983,4.69626-5.73988,4.69626s-8.37462-.91218-5.73987-4.69626c2.7789-3.99113,7.5462-11.59865,5.73987-12.00156C627.57893,304.41834,633.31881,311.80892,633.31881,316.4199Z",
    transform: "translate(-304.71267 -80)",
    fill: "#f9a825"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M629.60044,319.25722c0,1.82518-1.01722,1.85894-2.272,1.85894s-3.31495-.36107-2.272-1.85894c1.1-1.57982,2.987-4.59113,2.272-4.75061C627.32841,314.50661,629.60044,317.43205,629.60044,319.25722Z",
    transform: "translate(-304.71267 -80)",
    fill: "#ff6584",
    opacity: 0.5
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 343.80549,
    y: 240.65167,
    width: 4.05833,
    height: 22.99722,
    fill: "#e6e6e6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M656.316,317.77268c0,4.611-2.56983,4.69626-5.73988,4.69626s-8.37462-.91219-5.73988-4.69626c2.77891-3.99113,7.5462-11.59865,5.73988-12.00156C650.57615,305.77112,656.316,313.1617,656.316,317.77268Z",
    transform: "translate(-304.71267 -80)",
    fill: "#f9a825"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M652.59766,320.61c0,1.82518-1.01722,1.85894-2.272,1.85894s-3.315-.36107-2.272-1.85894c1.1-1.57982,2.987-4.59113,2.272-4.75062C650.32563,315.85938,652.59766,318.78482,652.59766,320.61Z",
    transform: "translate(-304.71267 -80)",
    fill: "#ff6584",
    opacity: 0.5
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 299.16384,
    y: 240.65167,
    width: 4.05833,
    height: 22.99722,
    fill: "#e6e6e6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M611.67437,317.77268c0,4.611-2.56983,4.69626-5.73988,4.69626s-8.37462-.91219-5.73987-4.69626c2.7789-3.99113,7.5462-11.59865,5.73987-12.00156C605.93449,305.77112,611.67437,313.1617,611.67437,317.77268Z",
    transform: "translate(-304.71267 -80)",
    fill: "#f9a825"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M607.956,320.61c0,1.82518-1.01722,1.85894-2.272,1.85894s-3.315-.36107-2.272-1.85894c1.1-1.57982,2.987-4.59113,2.272-4.75062C605.684,315.85938,607.956,318.78482,607.956,320.61Z",
    transform: "translate(-304.71267 -80)",
    fill: "#ff6584",
    opacity: 0.5
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M855.308,393.28819l-71.16778-12.8551c-4.97522-19.74867-11.82924-40.61389-.83662-58.47778,3.21351-13.48979,17.65636-17.34867,32.30225-20.68178,14.69848-3.34508,30.26476,1.93867,39.16765,14.1031,6.32952,8.6483,8.01607,17.317,5.44914,28.0925C867.282,353.95606,863.90907,379.62373,855.308,393.28819Z",
    transform: "translate(-304.71267 -80)",
    fill: "#2f2e41"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M748.74945,801.44986l-30.9838-21.17927,40.74427-142.07608,42.98139-71.01814L721.8782,615.60422l4.15169,94.57689-40.10833,20.34195-10.7293-117.31632a38.33519,38.33519,0,0,1,19.12887-36.76l65.61665-37.567,5.18791-53.95764,72.4062-11.11486c27.99306,36.09641,42.86193,69.22179,30.00786,96.07126l-65.264,84.10785Z",
    transform: "translate(-304.71267 -80)",
    fill: "#2f2e41"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M733.5471,786.10224s-5.53337-11.1438-11.28987-7.60223-21.034,19.55341-21.034,19.55341-28.11705,8.04045-8.70976,15.93887,26.34432,6.27569,26.71348,4.726,4.576-5.46033,4.576-5.46033l7.37917,3.39548,11.586-.51527s11.45082-27.44541,6.53876-27.44862S733.98926,791.12045,733.5471,786.10224Z",
    transform: "translate(-304.71267 -80)",
    fill: "#2f2e41"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M705.5,716.948s-12.35791-1.44387-12.53122,5.3126,4.90812,28.29623,4.90812,28.29623-8.60473,27.94953,8.60412,15.99614,19.63433-18.65208,18.53714-19.80706-2.0788-6.81419-2.0788-6.81419l6.872-4.33093,5.89033-9.99021s-16.75089-24.57193-19.43395-20.45737S709.9465,719.31574,705.5,716.948Z",
    transform: "translate(-304.71267 -80)",
    fill: "#2f2e41"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 504.88878,
    cy: 256.83574,
    r: 26.84554,
    fill: "#a0616a"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M824.85991,424.02739l-65.84145-.35309c7.21322-18.77838,14.93983-36.05282,28.53781-36.13005,10.72318-9.96283,9.552-23.42168,4.46064-38.03279l33.50752,4.14922c-1.55614,9.65874.67326,17.64052,9.117,22.8694C826.13064,392.89192,821.3721,408.8754,824.85991,424.02739Z",
    transform: "translate(-304.71267 -80)",
    fill: "#a0616a"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M859.21326,506.20765l-91.31248,6.76389-6.91869-42.83489c-19.07-18.21118-16.774-36.55522.83546-54.99447l6.428-23.76575,14.06-4.31641,0,0a14.78158,14.78158,0,0,0,15.46066,22.506l5.149-1.08947a14.78157,14.78157,0,0,0,9.35952-6.4456l18.53271-28.714,9.65446,1.19551a5.296,5.296,0,0,1,4.53045,4.15955l8.95425,42.3188C842.70375,437.55639,859.2858,483.68577,859.21326,506.20765Z",
    transform: "translate(-304.71267 -80)",
    fill: "#575a89"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M777.83,553.87405l9.181,16.6196a13.10951,13.10951,0,0,1-6.565,18.49431h0a13.10951,13.10951,0,0,1-18.01545-12.48086l.44129-17.764-19.026-68.15817,2.009-47.04913,19.9317,3.21494-.4196,43.59489Z",
    transform: "translate(-304.71267 -80)",
    fill: "#a0616a"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M830.8757,539.92595l-8.58547,16.9349a13.10951,13.10951,0,0,0,7.21715,18.24971l0,0a13.10951,13.10951,0,0,0,17.56124-13.11225l-1.07134-17.73721,16.59553-68.79036-3.67723-46.94821-19.80508,3.92016,1.96623,43.55254Z",
    transform: "translate(-304.71267 -80)",
    fill: "#a0616a"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M770.89853,451.03479l-30.46725-7.25785,11.20636-37.53433a23.06313,23.06313,0,0,1,17.55006-16.012l7.34879-1.47857Z",
    transform: "translate(-304.71267 -80)",
    fill: "#575a89"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M831.22822,440.85949l.61043-23.602,5.73058-38.47263a5.296,5.296,0,0,1,5.17933-4.51543h0a5.29607,5.29607,0,0,1,2.99518.8882l25.33052,58.96984C866.42921,444.87773,837.20476,428.05188,831.22822,440.85949Z",
    transform: "translate(-304.71267 -80)",
    fill: "#575a89"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M534.51542,796.11859,562.291,770.87824l-59.90234-135.12L450.04592,571.3283l85.51839,37.015,8.89877,94.24881,42.52543,14.63081-5.512-117.6769a38.33516,38.33516,0,0,0-24.00407-33.77892l-70.16088-28.18291L474.75,484.85327,401.50318,483.805c-22.7611,39.60423-32.93153,74.46017-16.506,99.286l76.21423,74.32976Z",
    transform: "translate(-304.71267 -80)",
    fill: "#2f2e41"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M547.46184,778.82551s3.94771-11.79908,10.13669-9.08311,23.524,16.47384,23.524,16.47384,28.95585,4.09592,10.81966,14.58911-25.23048,9.84022-25.80932,8.35606-5.28363-4.7789-5.28363-4.7789l-6.84189,4.37835-11.5467,1.08352S527.343,784.23522,532.208,783.55628,547.71425,783.85682,547.46184,778.82551Z",
    transform: "translate(-304.71267 -80)",
    fill: "#2f2e41"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M565.72871,706.4703s12.04178-3.13022,13.14293,3.53817-.96872,28.70241-.96872,28.70241,12.36794,26.5-6.32172,17.02771S549.56757,739.965,550.49545,738.67s1.1216-7.03538,1.1216-7.03538l-7.40247-3.34437-7.20868-9.08489s13.21125-26.64272,16.43483-22.9364S561.6502,709.42726,565.72871,706.4703Z",
    transform: "translate(-304.71267 -80)",
    fill: "#2f2e41"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 105.61216,
    cy: 264.29347,
    r: 26.84554,
    fill: "#ffb9b9"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M407.20644,432.75521l65.16685-9.40757c-9.728-17.60751-19.75758-33.65475-33.2369-31.86056-11.99181-8.39291-12.68332-21.88491-9.65041-37.05752l-32.61812,8.7194c2.8701,9.35283,1.76,17.56542-5.88421,23.9062C401.66447,402.09059,408.57662,417.26747,407.20644,432.75521Z",
    transform: "translate(-304.71267 -80)",
    fill: "#ffb9b9"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M402.28136,489.90487c23.15577,30.14906,46.90293,42.06121,72.43395-1.036l2.10487-19.23054c16.3834-20.6615,11.58559-38.51526-8.39313-54.35665l-9.63635-22.65548-14.52017-2.34112,0,0a14.78157,14.78157,0,0,1-12.21749,24.419l-5.24988-.37077a14.78154,14.78154,0,0,1-10.15726-5.09672l-22.30669-25.89142-9.3982,2.51231a5.296,5.296,0,0,0-3.91515,4.74325L377.97859,433.749C391.39345,448.61036,399.11117,467.60711,402.28136,489.90487Z",
    transform: "translate(-304.71267 -80)",
    fill: "#6c63ff"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M391.91558,471.536l-51.2861-10.41362,34.06292-31.6946-12.9642-23.44522-55.05667,58.55954a7.82938,7.82938,0,0,0,5.01869,12.95083l74.56336,8.25759,3.05968,13.49377a11.46529,11.46529,0,0,0,17.36137,7.12182h0a11.46528,11.46528,0,0,0,2.01763-17.673Z",
    transform: "translate(-304.71267 -80)",
    fill: "#ffb9b9"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M471.65226,554.89736,464.845,572.622a13.1095,13.1095,0,0,0,9.04688,17.41531h0A13.10951,13.10951,0,0,0,490.019,575.19671l-2.8809-17.53444,9.46855-70.12755-8.4625-46.3254-19.29992,5.92638,6.413,43.12267Z",
    transform: "translate(-304.71267 -80)",
    fill: "#ffb9b9"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M464.37017,452.08233l29.1791-11.38023-16.26342-35.63579a23.06313,23.06313,0,0,0-19.586-13.44541l-7.48233-.45353Z",
    transform: "translate(-304.71267 -80)",
    fill: "#6c63ff"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M368.25222,437.54244l31.1105-10.53267-10.96879-37.31846a5.296,5.296,0,0,0-5.75127-3.76h0a5.296,5.296,0,0,0-2.84451,1.2918l-31.78058,28.19542C354.09735,425.42755,360.57055,425.6788,368.25222,437.54244Z",
    transform: "translate(-304.71267 -80)",
    fill: "#6c63ff"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M428.15952,300.70948s16.418,3.08822,20.21481,23.56454a37.5903,37.5903,0,0,1,.32154,10.45542c-.37913,3.94147.17082,12.26631,8.7291,22.06872a214.59355,214.59355,0,0,1,15.5828,20.01252v0l-17.1554,4.567-7.665-28.42335a145.40214,145.40214,0,0,0-16.99045-39.05093l-.15759-.25284s-5.69788,15.22458-20.96975,17.31171l4.70883-6.19964s-17.85291,10.32033-27.96759,13.473a6.64564,6.64564,0,0,0-2.14449,11.55614q.10761.08465.21919.1694c7.43957,5.6506,22.61687,19.1335,16.62083,32.17639s.99628,15.421.99628,15.421l-12.89381-4.9052-5.90148-2.52714.59632,4.36339-28.80928.60356s-7.785-.04729,6.04333-20.82791c0,0,3.33666-7.79191.59741-13.74467a31.62067,31.62067,0,0,1-3.19327-14.489C359.81274,325.08075,368.63846,282.4584,428.15952,300.70948Z",
    transform: "translate(-304.71267 -80)",
    fill: "#2f2e41"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M785.93781,315.69149l24.80093,15.7824,2.25462-4.50926c14.97318,10.81875,11.75871,38.48709,4.50926,69.89351,0,0,26.20022,9.61311,29.31018,0,5.53474-17.10828,1.12732-57.493,1.12732-57.493l-9.01852-23.6736-14.65509-7.89121L811.86605,306.673S800.5929,301.0364,785.93781,315.69149Z",
    transform: "translate(-304.71267 -80)",
    fill: "#2f2e41"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 519.55384,
    cy: 266.12898,
    rx: 3.38194,
    ry: 4.50926,
    fill: "#a0616a"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 258.16783,
    cy: 67.72497,
    r: 3.46804,
    fill: "#e6e6e6"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 309.32135,
    cy: 176.96808,
    r: 3.46804,
    fill: "#e6e6e6"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 295.44921,
    cy: 98.93728,
    r: 3.46804,
    fill: "#e6e6e6"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 239.09364,
    cy: 135.35165,
    r: 3.46804,
    fill: "#e6e6e6"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M580.02815,148.38031a18.73185,18.73185,0,0,1-1.73284,29.32714c-1.7641,1.24549-.07638,4.17927,1.70693,2.92021a22.69892,22.69892,0,0,0,9.59069-16.52171,22.42737,22.42737,0,0,0-7.17338-18.117c-1.59841-1.473-3.996.91261-2.3914,2.3914Z",
    transform: "translate(-304.71267 -80)",
    fill: "#e6e6e6"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M611.24047,192.59776a18.73186,18.73186,0,0,1-1.73284,29.32714c-1.7641,1.24549-.07638,4.17927,1.70693,2.92021a22.699,22.699,0,0,0,9.59069-16.52171,22.42735,22.42735,0,0,0-7.17339-18.117c-1.5984-1.473-3.996.91261-2.39139,2.3914Z",
    transform: "translate(-304.71267 -80)",
    fill: "#e6e6e6"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M558.0806,230.95578a22.44466,22.44466,0,0,0-7.17338,18.117,22.67869,22.67869,0,0,0,9.59069,16.5217c1.78152,1.25779,3.47294-1.67337,1.70693-2.92021a18.73185,18.73185,0,0,1-1.73284-29.32714c1.604-1.47815-.79231-3.865-2.3914-2.39139Z",
    transform: "translate(-304.71267 -80)",
    fill: "#e6e6e6"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M585.46019,208.75981c-4.38686-.47694-9.83883-.40842-12.27142,4.02807-1.9155,3.49345.40871,8.83939,4.83431,8.36809a1.69969,1.69969,0,0,0,.44952-3.32154c-3.16085-.97791-5.94541,2.0487-5.90112,5.09643.05088,3.50128,3.48339,5.58733,6.34537,6.71711l.89906-3.26113a7.64994,7.64994,0,0,0-9.12458,6.768c-.29522,4.736,4.38264,8.16831,8.78852,7.55316,2.14635-.29966,1.233-3.5588-.89905-3.26113a3.96946,3.96946,0,1,1,.33605-7.79889,1.69252,1.69252,0,0,0,.89906-3.26113c-1.38221-.54564-3.08917-1.39606-3.699-2.85168-.39173-.93506.1914-2.831,1.45663-2.4396l.44953-3.32154a1.96362,1.96362,0,0,1-2.15476-1.60391,2.9867,2.9867,0,0,1,1.21244-2.86327c2.27495-1.94,5.64467-1.46241,8.37943-1.16508,2.16077.23492,2.14414-3.14883,0-3.382Z",
    transform: "translate(-304.71267 -80)",
    fill: "#e6e6e6"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M535.17368,185.35058c-4.38686-.477-9.83883-.40843-12.27142,4.02807-1.9155,3.49344.40871,8.83938,4.8343,8.36808a1.69969,1.69969,0,0,0,.44953-3.32154c-3.16085-.97791-5.94542,2.0487-5.90112,5.09643.05088,3.50128,3.48339,5.58733,6.34537,6.71712l.899-3.26114a7.64994,7.64994,0,0,0-9.12457,6.768c-.29522,4.736,4.38264,8.1683,8.78852,7.55316,2.14635-.29967,1.233-3.55881-.899-3.26114a3.96946,3.96946,0,1,1,.33605-7.79888,1.69253,1.69253,0,0,0,.899-3.26114c-1.3822-.54564-3.08916-1.39606-3.699-2.85168-.39173-.93506.1914-2.831,1.45663-2.43959l.44952-3.32155a1.96362,1.96362,0,0,1-2.15475-1.60391,2.98668,2.98668,0,0,1,1.21244-2.86326c2.27495-1.94,5.64467-1.46242,8.37943-1.16509,2.16077.23492,2.14414-3.14883,0-3.38194Z",
    transform: "translate(-304.71267 -80)",
    fill: "#e6e6e6"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M633.05789,263.99634c4.38685.47694,9.83883.40843,12.27142-4.02807,1.91549-3.49344-.40872-8.83939-4.83431-8.36808a1.69969,1.69969,0,0,0-.44953,3.32154c3.16085.9779,5.94542-2.0487,5.90113-5.09643-.05089-3.50129-3.4834-5.58734-6.34538-6.71712l-.899,3.26114a7.64994,7.64994,0,0,0,9.12457-6.768c.29522-4.736-4.38263-8.1683-8.78852-7.55316-2.14635.29967-1.233,3.5588.899,3.26114a3.96946,3.96946,0,1,1-.33605,7.79888,1.69253,1.69253,0,0,0-.899,3.26114c1.38221.54563,3.08917,1.39606,3.699,2.85168.39174.93506-.19139,2.831-1.45662,2.43959l-.44953,3.32154a1.96362,1.96362,0,0,1,2.15475,1.60391,2.98667,2.98667,0,0,1-1.21244,2.86327c-2.27494,1.94-5.64467,1.46241-8.37942,1.16509-2.16077-.23493-2.14415,3.14883,0,3.38194Z",
    transform: "translate(-304.71267 -80)",
    fill: "#e6e6e6"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 356.2442,
    cy: 3.46804,
    r: 3.46804,
    fill: "#e6e6e6"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 407.39772,
    cy: 112.71114,
    r: 3.46804,
    fill: "#e6e6e6"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 393.52558,
    cy: 34.68035,
    r: 3.46804,
    fill: "#e6e6e6"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 337.17001,
    cy: 71.09472,
    r: 3.46804,
    fill: "#e6e6e6"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M678.10452,84.12338a18.73184,18.73184,0,0,1-1.73284,29.32713c-1.76409,1.2455-.07638,4.17927,1.70693,2.92021A22.6989,22.6989,0,0,0,687.6693,99.849a22.42737,22.42737,0,0,0-7.17338-18.117c-1.5984-1.473-3.996.91261-2.3914,2.3914Z",
    transform: "translate(-304.71267 -80)",
    fill: "#e6e6e6"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M709.31684,128.34083A18.73185,18.73185,0,0,1,707.584,157.668c-1.7641,1.2455-.07638,4.17927,1.70693,2.92021a22.699,22.699,0,0,0,9.59069-16.5217,22.42735,22.42735,0,0,0-7.17339-18.117c-1.5984-1.473-3.996.91261-2.39139,2.3914Z",
    transform: "translate(-304.71267 -80)",
    fill: "#e6e6e6"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M656.157,166.69884a22.44471,22.44471,0,0,0-7.17338,18.117,22.67873,22.67873,0,0,0,9.59069,16.52171c1.78152,1.25779,3.47294-1.67337,1.70693-2.92021a18.73185,18.73185,0,0,1-1.73284-29.32714c1.604-1.47815-.79231-3.865-2.3914-2.3914Z",
    transform: "translate(-304.71267 -80)",
    fill: "#e6e6e6"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M683.53656,144.50288c-4.38686-.47694-9.83883-.40843-12.27142,4.02807-1.9155,3.49344.40871,8.83939,4.83431,8.36808a1.69969,1.69969,0,0,0,.44952-3.32154c-3.16085-.9779-5.94541,2.0487-5.90112,5.09643.05088,3.50129,3.48339,5.58734,6.34537,6.71712l.89906-3.26114a7.65,7.65,0,0,0-9.12458,6.768c-.29522,4.736,4.38264,8.1683,8.78853,7.55316,2.14634-.29967,1.23295-3.5588-.89906-3.26114a3.96946,3.96946,0,1,1,.33605-7.79888,1.69253,1.69253,0,0,0,.89906-3.26114c-1.38221-.54563-3.08917-1.39606-3.699-2.85168-.39173-.93505.1914-2.831,1.45663-2.43959l.44953-3.32154a1.96363,1.96363,0,0,1-2.15476-1.60391,2.98669,2.98669,0,0,1,1.21244-2.86327c2.27495-1.94,5.64467-1.46241,8.37943-1.16509,2.16077.23493,2.14415-3.14883,0-3.38194Z",
    transform: "translate(-304.71267 -80)",
    fill: "#e6e6e6"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M633.25005,121.09364c-4.38686-.47694-9.83883-.40842-12.27142,4.02807-1.9155,3.49344.40871,8.83939,4.83431,8.36809a1.69969,1.69969,0,0,0,.44952-3.32154c-3.16085-.97791-5.94542,2.0487-5.90112,5.09643.05088,3.50128,3.48339,5.58733,6.34537,6.71711l.89906-3.26113a7.64994,7.64994,0,0,0-9.12458,6.768c-.29522,4.736,4.38264,8.1683,8.78852,7.55316,2.14635-.29966,1.233-3.5588-.899-3.26113a3.96946,3.96946,0,1,1,.33605-7.79889,1.69252,1.69252,0,0,0,.89906-3.26113c-1.38221-.54564-3.08917-1.39606-3.699-2.85169-.39173-.935.1914-2.831,1.45663-2.43959l.44953-3.32154a1.96363,1.96363,0,0,1-2.15476-1.60391,2.9867,2.9867,0,0,1,1.21244-2.86327c2.27495-1.94,5.64467-1.46241,8.37943-1.16508,2.16077.23492,2.14414-3.14883,0-3.382Z",
    transform: "translate(-304.71267 -80)",
    fill: "#e6e6e6"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M731.13426,199.73941c4.38685.47694,9.83883.40842,12.27142-4.02807,1.9155-3.49344-.40872-8.83939-4.83431-8.36809a1.69969,1.69969,0,0,0-.44953,3.32154c3.16085.97791,5.94542-2.0487,5.90113-5.09643-.05089-3.50128-3.4834-5.58733-6.34538-6.71711l-.899,3.26113a7.64993,7.64993,0,0,0,9.12457-6.768c.29522-4.736-4.38263-8.1683-8.78852-7.55316-2.14635.29967-1.233,3.5588.899,3.26113a3.96947,3.96947,0,1,1-.33605,7.79889,1.69252,1.69252,0,0,0-.899,3.26113c1.38221.54564,3.08917,1.39606,3.699,2.85169.39173.93505-.1914,2.831-1.45663,2.43959l-.44953,3.32154a1.96363,1.96363,0,0,1,2.15476,1.60391,2.9867,2.9867,0,0,1-1.21245,2.86327c-2.27494,1.94-5.64466,1.46241-8.37942,1.16508-2.16077-.23492-2.14415,3.14883,0,3.38195Z",
    transform: "translate(-304.71267 -80)",
    fill: "#e6e6e6"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M850.67867,314.323l-4.66743-10.33342-3.70119-8.209-5.37229-11.89921-3.71242-8.21017-5.03668-11.17458a1.13508,1.13508,0,0,0-1.95183-.19476l-5.19762,7.24179-4.02465,5.59157-5.82781,8.10791-4.01454,5.60384-5.82782,8.10791-4.01348,5.59268-2.9862,4.15437a1.04924,1.04924,0,0,0-.213.5452,1.18051,1.18051,0,0,0,.08987.57543,1.12422,1.12422,0,0,0,.91995.65825l54.40459,5.4286a1.06392,1.06392,0,0,0,.91753-.339.84515.84515,0,0,0,.11435-.12454,1.18034,1.18034,0,0,0,.20179-.54632A1.049,1.049,0,0,0,850.67867,314.323Z",
    transform: "translate(-304.71267 -80)",
    fill: "#6c63ff"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "532.225 203.881 512.302 197.135 516.327 191.544 528.513 195.671 532.225 203.881",
    fill: "#e6e6e6"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "541.299 223.99 502.46 210.847 506.474 205.243 537.597 215.78 541.299 223.99",
    fill: "#e6e6e6"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M850.46362,315.57036a1.06392,1.06392,0,0,1-.91753.339L823.09534,313.27l-25.76443-8.72254,4.01348-5.59268Z",
    transform: "translate(-304.71267 -80)",
    fill: "#e6e6e6"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 523.00376,
    cy: 179.3513,
    r: 9.01852,
    fill: "#6c63ff"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M433.21233,302.72737l-5.67036-9.81894-4.498-7.801-6.5272-11.307-4.50925-7.801-6.12131-10.61929a1.13509,1.13509,0,0,0-1.96152,0l-4.45291,7.72208-3.44958,5.96354-4.994,8.64648-3.4383,5.97476-4.994,8.64648-3.43837,5.96354-2.559,4.43034a1.0492,1.0492,0,0,0-.15784.56365,1.18036,1.18036,0,0,0,.14656.56366,1.12419,1.12419,0,0,0,.98076.56366h54.67476a1.06385,1.06385,0,0,0,.87933-.42839.84376.84376,0,0,0,.10142-.13527,1.18025,1.18025,0,0,0,.14656-.56366A1.04911,1.04911,0,0,0,433.21233,302.72737Z",
    transform: "translate(-304.71267 -80)",
    fill: "#6c63ff"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    points: "111.804 193.8 91.31 189.066 94.759 183.102 107.295 185.999 111.804 193.8",
    fill: "#e6e6e6"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    points: "122.829 212.908 82.877 203.687 86.316 197.712 118.331 205.107 122.829 212.908",
    fill: "#e6e6e6"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M433.12219,303.99a1.06385,1.06385,0,0,1-.87933.42839h-26.5821L379.15758,298.297l3.43837-5.96354Z",
    transform: "translate(-304.71267 -80)",
    fill: "#e6e6e6"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 100.19281,
    cy: 170.30724,
    r: 9.01852,
    fill: "#6c63ff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderSvg);
export default __webpack_public_path__ + "static/media/header-svg.79becd5ec7481918ec28acb13107c373.svg";
export { ForwardRef as ReactComponent };